import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { delay, map, tap } from 'rxjs/operators';
import { SNACKBAR_CLOSE, SNACKBAR_OPEN, SnackbarClose, SnackbarOpen } from '../actions';
import {SnackBarComponent} from "@components/snackbar/snackbar.component";
import 'rxjs/add/operator/map';

@Injectable()
export class SnackbarEffects {

  constructor(
    private actions: Actions,
    private matSnackBar: MatSnackBar
  ) {}

  @Effect({dispatch: false})
  closeSnackbar: Observable<any> = this.actions.ofType(SNACKBAR_CLOSE)
    .pipe(tap(() => this.matSnackBar.dismiss()));

  @Effect()
  showSnackbar: Observable<any> = this.actions.ofType<SnackbarOpen>(SNACKBAR_OPEN)
    .pipe(
      map((action: SnackbarOpen) => {
        return action.payload;
      }),
      tap(payload => this.matSnackBar.openFromComponent(SnackBarComponent, {
        ...payload,
        panelClass: 'snackbar-container',
        duration: 2000,
      })),
      delay(2000),
      map(() => new SnackbarClose())
    );
}



// WEBPACK FOOTER //
// ./src/app/store/effects/snackbar.effect.ts